import React, { useEffect, useState } from "react";
import { useEditTodoMutation } from "../features/api/apiSlice";
import Error from "./ui/Error";
import Spinner from "./ui/Spinner";

const EditForm = ({ todo, setEditMode }) => {
  const { id, text, completed, color } = todo;
  const [inputText, setInputText] = useState(text);
  const [isCompleted, setIsCompleted] = useState(completed);
  const [todoColor, setTodoColor] = useState(color);
  const [editTodo, { isLoading, isError, isSuccess }] = useEditTodoMutation();

  const handleEdit = (e) => {
    e.preventDefault();
    editTodo({ id, data: { text: inputText, completed: isCompleted, color: todoColor } });
    // setEditMode(false);
  };

  useEffect(() => {
    if (isSuccess) setEditMode(false);
  }, [isSuccess, setEditMode]);
  return (
    <div className='fixed top-0 left-0 min-h-screen w-full flex items-center justify-center bg-neutral-900/25'>
      <div className='w-full h-full  max-w-md bg-white shadow-md rounded'>
        <h1 className='text-2xl text-center mt-4 p-2'>Edit Todo</h1>
        <form className=' px-8 pt-6 pb-8 mb-4' onSubmit={handleEdit}>
          <div className='mb-4'>
            <input
              required
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
              type='text'
              placeholder='Text'
            />
          </div>
          <div className='flex gap-4'>
            <div className='flex items-center mb-4'>
              <input
                checked={todoColor === "green"}
                onChange={(e) => setTodoColor(e.target.value)}
                id='green'
                type='radio'
                value='green'
                name='color'
                className='w-4 h-4 border-gray-300 '
              />
              <label htmlFor='green' className='block ml-2 text-sm font-medium text-gray-900 dark:text-gray-300'>
                Green
              </label>
            </div>
            <div className='flex items-center mb-4'>
              <input
                checked={todoColor === "yellow"}
                onChange={(e) => setTodoColor(e.target.value)}
                id='yellow'
                type='radio'
                name='color'
                value='yellow'
                className='w-4 h-4 border-gray-300 '
              />
              <label htmlFor='yellow' className='block ml-2 text-sm font-medium text-gray-900'>
                Yellow
              </label>
            </div>
            <div className='flex items-center mb-4'>
              <input
                checked={todoColor === "red"}
                onChange={(e) => setTodoColor(e.target.value)}
                id='red'
                type='radio'
                name='color'
                value='red'
                className='w-4 h-4 border-gray-300 '
              />
              <label htmlFor='red' className='block ml-2 text-sm font-medium text-gray-900 '>
                Red
              </label>
            </div>
          </div>
          <div className='flex items-center mb-4'>
            <input
              checked={isCompleted}
              onChange={() => setIsCompleted(!isCompleted)}
              id='completed'
              type='checkbox'
              className='w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
            />
            <label htmlFor='completed' className='ml-2 text-sm font-medium text-gray-900 dark:text-gray-300'>
              Completed
            </label>
          </div>
          {isError && <Error message='Editing todo failed!!' />}
          <div className='flex items-center justify-between'>
            <button
              className='w-full flex items-center justify-center bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-4 rounded focus:outline-none focus:shadow-outline'
              type='submit'
            >
              {isLoading ? <Spinner customStyle='w-4 h-4 border-2' /> : "Edit Todo"}
            </button>
          </div>
          <div className='flex items-center justify-between'>
            <button
              onClick={() => setEditMode(false)}
              className='w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 mt-4 rounded focus:outline-none focus:shadow-outline'
              type='submit'
            >
              cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditForm;
